
import Vue from "vue";

const BedManagerService = class {
  _DEBUG = false;
  DEFAULT_POLL_INTERVAL_IN_SECS = 60; // In Seconds
  VERSION = '0.1.1';

  // Properties
  _tenants =  {
    /**
     * Item Type
     * @property id
     * @property label
     */
    data: [],
    selected: null,
  };
  _configuration = null;
  _packages = {
    query: {
      skip: 0,
      limit: 30,
    },
    headers: [
      {
        key: 'label',
        label: 'Label',
        sortable: true,
        active: true,
        searchLabel: 'Search by Label(s)',
        searchable: 'label',
      }, {
        key: 'version',
        label: 'Version',
        sortable: true,
        active: true,
        searchLabel: 'Search by Version(s)',
        searchable: 'version',
      }, {
        key: 's3Uri',
        label: 'S3 Uri',
        sortable: false,
        active: true,
      }, {
        key: 'signature',
        label: 'Signature',
        sortable: false,
        active: false,
      }, {
        key: 'additional',
        label: 'Additional Info',
        sortable: false,
        active: true,
        renderAsHtml: true
      }, {
        key: 'fileName',
        label: 'File Name',
        sortable: true,
        active: false,
        searchLabel: 'Search by File Name(s)',
        searchable: 'fileName',
      }, {
        key: 'zipSourceFolder',
        label: 'Zip Source Folder',
        sortable: false,
        active: false,
      }, {
        key: 'pathOnSensor',
        label: 'Package Path',
        sortable: false,
        active: false,
      }, {
        key: 'command',
        label: 'Command',
        sortable: false,
        active: false,
      }, {
        key: 'created',
        label: 'Created',
        sortable: true,
        active: true,
        searchLabel: 'Search within Date Range',
        searchType: 'dateRange',
        searchable: 'created',
      }, {
        key: 'createdBy',
        label: 'Created By',
        sortable: true,
        active: true,
        searchLabel: 'Search by User',
        searchable: 'createdBy',
      },
    ],
    total: 0,
    /**
     * Item Type
     * @property s3Uri
     * @property signature
     * @property signatureS3Uri 
     * @property fileName 
     * @property label
     * @property version
     * @property created
     * @property modified
     */
    data: [],
  };
  _devices = {
    searchValue: '',
    query: {
      skip: 0,
      limit: 30,
      location: [],
      unit: [],
      area: [],
      model: [],
      firmwareVersion: "",
    },
    headers: [
      {
        key: 'status',
        label: 'Status',
        sortable: true,
        active: true,
        renderAsHtml: true,
      },
      {
        key: 'tenant',
        label: 'Tenant',
        sortable: false,
        active: true,
        searchable: 'scope',
        searchLabel: 'Select Tenant',
        searchType: 'options',
        searchItems: [],
      },
      {
        key: 'deviceId',
        label: 'Device ID',
        sortable: true,
        active: true,
        renderAsHtml: true,
        searchLabel: 'Search by Device ID(s)',
        searchable: 'deviceId',
      },{
        key: 'serial',
        label: 'MAC',
        sortable: true,
        active: true,
        renderAsHtml: true,
        searchLabel: 'Search by MAC(s)',
        searchable: 'serial',
      }, {
        key: 'firmwareVersionFormatted',
        label: 'Version(s)',
        default: '0.0.0',
        sortable: true,
        active: true,
        renderAsHtml: true,
        searchLabel: 'Search by Version(s)',
        searchable: 'firmwareVersion',
        
      }, {
        key: 'poc',
        label: 'Location',
        sortable: false,
        active: true,
        searchLabel: 'Filter POC(s)',
        searchable: 'pocTree',
      }, {
        key: 'location',
        label: 'Facility',
        sortable: true,
        active: false,
        searchLabel: 'Search by Facility(s)',
        searchable: 'location',
        renderAsHtml: true,
      }, {
        key: 'unit',
        label: 'Area',
        sortable: true,
        active: false,
        searchLabel: 'Search by Area(s)',
        searchable: 'unit',
        renderAsHtml: true,
      }, {
        key: 'area',
        label: 'Location',
        sortable: true,
        active: false,
        searchLabel: 'Search by Location(s)',
        searchable: 'area',
        renderAsHtml: true,
      },
      {
        key: 'lastHealthReported',
        label: 'Last Seen',
        sortable: true,
        active: true,
      },
      {
        key: 'registeredOn',
        label: 'Provisioned On',
        sortable: true,
        active: true,
      },
    ],
    data: [],
  };
  _locations = {
    query: {
      skip: 0,
      limit: 30,
    },
    data: [],
  };
  _jobs = {
    query: {
      skip: 0,
      limit: 30,
    },
    headers: [
      {
        key: 'tenant',
        label: 'Tenant',
        sortable: false,
        active: true,
        searchable: 'scope',
        searchLabel: 'Select Tenant',
        searchType: 'options',
        searchItems: [],
      },
      {
        key: '_id',
        label: 'ID',
        sortable: false,
        active: true,
      }, {
        key: 'status',
        label: 'Status',
        sortable: true,
        active: true,
        renderAsHtml: true,
        searchLabel: 'Search by Status(s)',
        searchable: 'status',
        searchItems: [{
          value: 'queued',
          text: 'Queued'
        }, {
          value: 'progress',
          text: 'In Progress'
        }, {
          value: 'awaiting',
          text: 'Awaiting User Acknowledgement'
        }, {
          value: 'succeeded',
          text: 'Success'
        }, {
          value: 'error',
          text: 'Failed/Error'
        }, {
          value: 'canceled',
          text: 'Canceled'
        }],
        searchType: 'options',
        searchMulti: true
      }, {
        key: 'tasksFormatted',
        label: 'Task List',
        sortable: false,
        active: true,
        renderAsHtml: true,
        searchLabel: 'Search by Task Type(s)',
        searchable: 'taskType',
        searchItems: [],
        searchType: 'options',
        searchMulti: true
      }, {
        key: 'tasksPackages',
        label: 'Task Package(s)',
        sortable: false,
        active: true,
        renderAsHtml: true,
        searchable: 'packageId',
        searchLabel: 'Search for Package(s)',
        searchItems: [],
        searchType: 'options',
        searchMulti: true,
        searchCallback: async (slug) => {
          this.fetchPackages(slug);
        }
      }, {
        key: 'lastUpdatedAtReduced',
        label: 'Last Updated',
        sortable: false,
        active: true,
      }, {
        key: 'createdFormatted',
        label: 'Created',
        sortable: true,
        sortKey: 'created',
        active: true,
        searchLabel: 'Search within Date Range',
        searchType: 'dateRange',
        searchable: 'created',
      },
      {
        key: 'createdBy',
        label: 'Created By',
        sortable: true,
        active: true,
        searchLabel: 'Search by User',
        searchable: 'createdBy',
      }
    ],
    /**
     * Item Type
     * @property id
     * @property deviceList
     * @property taskList 
     * @property created
     */
    data: [],
  };
  _selectedJob = {
    headers: [
      {
        key: 'id',
        label: 'Device',
        renderAsHtml: true,
        sortable: true,
        active: true,
      }, {
        key: 'mac',
        label: 'MAC',
        sortable: true,
        active: true,
        renderAsHtml: true,
      }, {
        key: 'ipPrefix',
        label: 'Device IP Prefix',
        sortable: true,
        active: false,
      }, {
        key: 'taskIndex',
        label: 'Task Number',
        sortable: true,
        active: true,
      }, {
        key: 'taskType',
        label: 'Task Type',
        sortable: false,
        active: true,
        renderAsHtml: true,
      }, {
        key: 'taskStatus',
        label: 'Task Status',
        sortable: true,
        active: true,
        renderAsHtml: true,
      }, {
        key: 'taskDetails',
        label: 'Package Details',
        sortable: false,
        active: true,
        renderAsHtml: true,
      }, {
        key: 'lastUpdatedAt',
        label: 'Last Updated',
        sortable: true,
        active: true,
      },
    ],
    data: []
  };
  _selectedDevice = {
    headers: [
      {
        key: 'id',
        label: 'Device ID',
        sortable: true,
        active: true,
      },
    ],
    data: []
  };
  _actionQueue = [];
  _tabIndex = 0;

  constructor() {
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED DM SERVICE');
      this.bootstrapDebugData();
    }
  }

  bootstrapDebugData() {
    // MOCK PACKAGES
    for (let i = 0; i < 31; i += 1) {
      this.packages.data.push({
        id: (Math.random() + 1).toString(36).substring(7),
        s3Uri: (Math.random() + 1).toString(36).substring(7),
        signature: (Math.random() + 1).toString(36).substring(7),
        signatureS3Uri: (Math.random() + 1).toString(36).substring(7),
        fileName: (Math.random() + 1).toString(36).substring(7),
        label: (Math.random() + 1).toString(36).substring(7),
        version: (Math.random() + 1).toString(36).substring(7),
        createdBy: (Math.random() + 1).toString(36).substring(7),
        created: new Date(),
        modified: new Date(),
      })
    }
    this.packages = { ...this.packages };

    // MOCK DEVICES
    for (let i = 0; i < 85; i += 1) {
      this.devices.data.push({
        deviceId: (Math.random() + 1).toString(36).substring(7),
        tenant: (Math.random() + 1).toString(36).substring(1),
        model: 'ProCuity 3009',
        poc: {
          location: (Math.random() + 1).toString(36).substring(1),
          unit: (Math.random() + 1).toString(36).substring(1),
          area: (Math.random() + 1).toString(36).substring(1),
        },
        lastSeen: new Date(),
      })
    }
    for (let i = 0; i < 16; i += 1) {
      this.devices.data.push({
        deviceId: (Math.random() + 1).toString(36).substring(7),
        tenant: (Math.random() + 1).toString(36).substring(1),
        model: 'ProCuity 3009',
        poc: null, // Unassigned devices must be supported
        lastSeen: new Date(),
      })
    }
    this.devices = { ...this.devices };

    // MOCK LOCATIONS
    for (let i = 0; i < 100; i += 1) {
      this.locations.data.push({
        tenant: (Math.random() + 1).toString(36).substring(1),
        location: (Math.random() + 1).toString(36).substring(1),
        unit: (Math.random() + 1).toString(36).substring(1),
        area: (Math.random() + 1).toString(36).substring(1),
      })
    }
    this.locations = { ...this.locations };

    // MOCK TENANTS
    for (let i = 0; i < 100; i += 1) {
      this.tenants.data.push({
        id: (Math.random() + 1).toString(36).substring(1),
        label: (Math.random() + 1).toString(36).substring(3),
      })
    }
    this.tenants = { ...this.tenants };

    // MOCK JOBS
    for (let i = 0; i < 16; i += 1) {
      this.jobs.data.push({
        id: (Math.random() + 1).toString(36).substring(3),
        deviceList: [
          (Math.random() + 1).toString(36).substring(3),
          (Math.random() + 1).toString(36).substring(3),
          (Math.random() + 1).toString(36).substring(3),
        ],
        taskList: [
          {
            type: "OTA",
            packageID: (Math.random() + 1).toString(36).substring(3)
          },
          {
            type: "OTA",
            packageID: (Math.random() + 1).toString(36).substring(3)
          },
          {
            type: "OTA",
            packageID: (Math.random() + 1).toString(36).substring(3)
          }
        ],
        createdBy: (Math.random() + 1).toString(36).substring(7),
        created: new Date(),
      })
    }
    this.jobs = { ...this.jobs };
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  // Property Getters & Setters
  get tenants() {
    return this._tenants;
  }

  set tenants(value) {
    this._tenants = {...value};
  }

  get packages() {
    return this._packages;
  }

  set packages(value) {
    this._packages = {...value};
  }

  fetchPackages(search = null) {
    Vue.prototype.$DeviceManagerAPIService.getPackages(search ? { search } : this.packages.query).then((res) => {
      if (res && Array.isArray(res.items)) {
        const taskPackagesHeader = this.jobs.headers.find((header) => header.key === 'tasksPackages');
        if (search !== null || (taskPackagesHeader && !taskPackagesHeader.searchItems.length)) {
          if (taskPackagesHeader && res.items.length) {
            res.items.forEach((item) => {
              const found = taskPackagesHeader.searchItems.find((existing) => existing.value === item._id);
              if (!found) taskPackagesHeader.searchItems.push({ text: `${item.label} (${item.version})`, value: item._id }) 
            })
          }
        } 
        if (search === null) {
          this.packages.data = res.items;
          this.packages.total = res.count;
        }
      }
    })
  }
  
  get devices() {
    return this._devices;
  }

  set devices(value) {
    this._devices = {...value};
  }

  fetchDevices() {
    if (this.tenants.selected && this.configuration && this.configuration.tasks) {
      const message = {};
      const query = Object.keys(this.devices.query).reduce((res, val) => {
        if (this.devices.query[val] && this.devices.query[val].length && val !== 'area') {
          res[val] = this.devices.query[val];
        } else if (val === 'area') {
          message.area = this.devices.query[val];
        }
        return res;
      }, {});
      if (!query.model || !query.model.length) {
        query.model = Array.from(this.configuration.tasks.reduce((iterator, val) => {
          if (Array.isArray(val.models)) {
            val.models.forEach((model) => iterator.add(model));
          }
          return iterator;
        }, new Set()));
      }
      Vue.prototype.$DeviceAPIService.getBedsWithAttributes(this.tenants.selected.value, query, message).then((res) => {
        const devices = res && Array.isArray(res.data) ? res.data.map((device) => { 
          device.tenant = this.tenants.selected.value;
          device.key = `${this.tenants.selected.value}-${device.deviceId}-${device.registeredOn}`
          return device;
        }) : [];
        this.devices.data = devices;
        this.devices.total = res && res.count ? res.count : 0;
      });
    }
  }

  get locations() {
    return this._locations;
  }

  set locations(value) {
    this._locations = {...value};
  }

  get jobs() {
    return this._jobs;
  }

  set jobs(value) {
    this._jobs = {...value};
  }

  fetchJobs() {
    if (this.tenants.selected) {
      Vue.prototype.$DeviceManagerAPIService.getJobs({...this.jobs.query, scope: this.tenants.selected.value}).then((res) => {
        this.jobs.data = res.items;
        this.jobs.total = res.count;
      });
    }
  }

  get selectedJob() {
    return this._selectedJob;
  }

  set selectedJob(value) {
    this._selectedJob = {...value};
  }

  get selectedDevice() {
    return this._selectedDevice;
  }

  set selectedDevice(value) {
    this._selectedDevice = {...value};
  }

  fetchDeviceAttributes() {
    if (this.tenants.selected) {
      Vue.prototype.$DeviceAPIService.getDeviceAttributes(this.tenants.selected.value, this.selectedDevice.id).then((res) => {
        this.selectedDevice.data = res;
        this.devices.total = res.count;
      });
    }
  }

  get configuration() {
    return this._configuration;
  }

  set configuration(value) {
    this._configuration = {...value};
  }

  fetchConfiguration() {
    Vue.prototype.$DeviceManagerAPIService.getConfiguration().then((res) => {
      this.configuration = res;
      if (Array.isArray(res.tasks)) {
        const header = this.jobs.headers.find((header) => header.key === 'tasksFormatted');
        header.searchItems = [];
        res.tasks.forEach((task) => {
          header.searchItems.push({text: task.type, value: task.type});
        })
      }
    });
  }

  get actions() {
    return this._actionQueue;
  }

  set actions(value) {
    this._actionQueue.push(value);
  }

  get tabIndex() {
    return this._tabIndex;
  }

  set tabIndex(value) {
    this._tabIndex = value;
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$BedManagerService) {
  Vue.prototype.$BedManagerService = new BedManagerService();
}

export default Vue.prototype.$BedManagerService;
